










import Vue from 'vue'

import Localized from '@/components/Localized'

interface LocalizedObject {
  byLanguage: {
    [key: string]: string | undefined
  }
}

export default Vue.extend({
  components: {
    Localized,
  },
  computed: {
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  props: {
    points: {
      type: Array,
      required: true,
    },
    anchors: {
      type: Object,
      default: () => ({}),
    },
    locale: {
      type: String,
    },
  },
})
